import { HITS_TO_STUN } from '../game/combat'
import { getRacerIdentity } from '../game/racer-config'
import type { SimulationState } from '../game/types'
import { formatOrdinal } from './race-format'

interface LeaderboardProps {
  state: SimulationState
}

export function Leaderboard({ state }: LeaderboardProps) {
  const playerIndex = Math.max(0, state.ranking.indexOf(state.race.playerId))
  const mobileContext = new Set([
    state.ranking[0],
    state.race.playerId,
    state.ranking[playerIndex - 1],
    state.ranking[playerIndex + 1],
  ])
  return (
    <aside className="leaderboard" aria-label="Race leaderboard">
      <div className="leaderboard__header">
        <span>LIVE GRID</span>
        <small>{state.ranking.length} RACERS</small>
      </div>
      <ol>
        {state.ranking.map((vehicleId, index) => {
          const identity = getRacerIdentity(vehicleId)
          const vehicle = state.vehicles.find((candidate) => candidate.id === vehicleId)
          const displayName = vehicle?.displayName ?? identity.name
          const status = vehicle?.driverStunTimer
            ? 'DRIVER HIT'
            : vehicle?.reloadTimer
              ? 'RELOADING'
              : vehicle?.driverHitCount
                ? `HIT ${vehicle.driverHitCount}/${HITS_TO_STUN}`
                : vehicleId === state.race.playerId
                  ? 'YOU'
                  : ''
          return (
            <li
              key={vehicleId}
              className={
                vehicleId === state.race.playerId
                  ? 'leaderboard__entry leaderboard__entry--player'
                  : 'leaderboard__entry'
              }
              data-mobile-hidden={!mobileContext.has(vehicleId) || undefined}
              style={{ borderColor: identity.accent }}
            >
              <strong>{formatOrdinal(index + 1)}</strong>
              <span>{displayName}</span>
              <small>{status}</small>
            </li>
          )
        })}
      </ol>
    </aside>
  )
}
